import React, { Component } from 'react';
import { connect } from 'react-redux';
import BuyButton from '../Components/BuyButton';
import { receive, loadError } from '../Actions/Cart.action';
import { catchError } from '../Actions/Error.action';
import { setAddonSelection } from '../Actions/AddonProduct.action';
import { add as addToCartService, addMultiple as addMultipleToCartService } from '../Services/Cart.service';
import withReactiveStyleBuyButton from './withReactiveStyleBuyButton';

class BuyButtonContainer extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const addons = this.props.addonMainArticleNumber === this.props.articleNumber ? this.props.addonSelection : null;
        const clearAddons = () => this.props.clearAddons(this.props.articleNumber);
        return (
            <BuyButton {...this.props}
                onClick={(articleNumber, quantityFieldId, price, currency) => this.props.onClick({ articleNumber, quantityFieldId, price, currency, packSize: this.props.packSize, addons, clearAddons })} />
        );
    }
}

const mapStateToProps = state => {
    return {
        addonMainArticleNumber: state.addons.mainArticleNumber,
        addonSelection: state.addons.selection,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onSuccess: (cart) => {
            dispatch(receive(cart));
        },
        onError: (ex) => {
            dispatch(catchError(ex, error => loadError(error)));
        },
        clearAddons: (articleNumber) => dispatch(setAddonSelection(articleNumber, [])),
    }
}

const onClick = async ({ articleNumber, quantityFieldId, price, currency, packSize, addons, clearAddons }) => {
    // Products sold in packs (2-pack, 4-pack, ...) are always added a whole pack at a time,
    // also when no quantity field is rendered. The backend re-aligns the quantity as well.
    const pack = Math.max(1, parseInt(packSize) || 1);
    const entered = quantityFieldId ? parseInt(document.getElementById(quantityFieldId).value) : NaN;
    const quantity = isNaN(entered) || entered < pack
        ? pack
        : Math.ceil(entered / pack) * pack;
    if (!addons || !addons.length) {
        return addToCartService({ articleNumber, quantity, price, currency });
    }
    const cart = await addMultipleToCartService({
        articles: [{ articleNumber, quantity, price }, ...addons],
        currency,
    });
    clearAddons();
    return cart;
}
export default connect(mapStateToProps, mapDispatchToProps)(
            withReactiveStyleBuyButton(BuyButtonContainer, onClick, 'buy-button-container'));
